import ForgetPassword from "components/login/forgetPassword/forgetPassword";
import FilterInMachinesGroup from "components/myMachines/FilterInMachinesGroup";
import MachinesInGroups from "components/myMachines/MachinesInGroups";
import OrderCard from "components/order/orderCard";
import OrderDetails from "components/order/orderDetails";
import { useUserContext } from "context/userContext";
import useDeviceRedirect from "hooks/useDeviceRedirect";
import Cart from "pages/Cart";
import UserMachines from "pages/UserMachines";
import ChangePasswordPage from "pages/changePasswordPage";
import Orders from "pages/orders/orders";
import ResetPassPage from "pages/resetPassPage";
import UserProfile from "pages/userProfile";
import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import NavBar from "./components/NavBar";
import LandingPage from "./pages/LandingPage";
import Products from "./pages/Products";
import CacheBuster from "react-cache-buster";
import packageFile from "../package.json";

function App() {
  useDeviceRedirect();

  const { setIsAuth_ } = useUserContext();

  const isProductionOrStaging =
    process.env.REACT_APP_NODE_ENV === "production" || process.env.REACT_APP_NODE_ENV === "staging";

  const version = packageFile.version;

  return (
    <>
      <CacheBuster
        currentVersion={version}
        isEnabled={isProductionOrStaging}
        isVerboseMode={false}
        metaFileDirectory={"."}
      >
        <Router>
          <ForgetPassword />
          <NavBar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/reset-password" element={<ResetPassPage />} />
            <Route path="/login" element={<OrderCard />} />
            <Route
              path="/profile/change-password"
              element={<ChangePasswordPage />}
            />
            <Route path="/Filters" element={<Products />} />
            <Route path="/groups" element={<UserMachines />} />
            <Route path="/group/:groupId" element={<MachinesInGroups />} />
            <Route path="/orders/:orderId" element={<OrderDetails />} />
            <Route
              path="/machine/:machineId"
              element={<FilterInMachinesGroup />}
            />
            <Route path="/Orders" element={<Orders />} />
            <Route path="/Cart" element={<Cart />} />
          </Routes>
        </Router>
      </CacheBuster>
    </>
  );
}

export default App;
